import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { SELECT_ACCURACY_PROGRESS_TOGGLE } from '@containers/upf-assign/upf-assign-action-types';
import { clearCellSelection } from '@containers/upf-assign/upf-assign-actions';

import ToolTip from '@components/tooltip/tooltip';
import SvgIcon from '@components/svg-icon/svg-icon';

import { Info } from '@helpers/icon-dictionary';
import useToolTip from '@helpers/hooks/use-tool-tip';
import useManageLocalStorage from '@helpers/hooks/use-manage-local-storage';
import { LOCAL_STORAGE_KEYS } from '@helpers/constants';

import {
  AccuracyProgressWrapper,
  AccuracyWrapper,
  ProgressWrapper,
  IconWrapper,
  ToolTipInfo
} from './accuracy-progress-toggle.styled';
import { ACCURACY, PROGRESS } from './accuracy-progress-constants';

import getTranslations from './translations';

const AccuracyProgressToggle = ({ i18n }) => {
  const dispatch = useDispatch();
  const currentSelection = useSelector(state => state.UPFAssignReducer.accuracyProgressToggle.currentFilter);

  const { targetRef, showToolTip, onHoverHandlers } = useToolTip();

  useManageLocalStorage({
    key: LOCAL_STORAGE_KEYS.ACCURACY_PROGRESS_FILTER,
    value: currentSelection,
    defaultValue: ACCURACY,
    updateValueFromLocalStorage: updatedValue => {
      dispatch({ type: SELECT_ACCURACY_PROGRESS_TOGGLE, selectedFilter: updatedValue });
    }
  });

  const {
    ACCURACY_BUTTON_TEXT,
    ACCURACY_BUTTON_TITLE,
    ACCURACY_INFO_TEXT,
    PROGRESS_BUTTON_TEXT,
    PROGRESS_BUTTON_TITLE,
    PROGRESS_INFO_TEXT
  } = getTranslations({
    i18n
  });

  return (
    <AccuracyProgressWrapper>
      <AccuracyWrapper
        selected={currentSelection === ACCURACY}
        data-testid="accuracy-wrapper"
        title={ACCURACY_BUTTON_TITLE}
        onClick={() => {
          dispatch({ type: SELECT_ACCURACY_PROGRESS_TOGGLE, selectedFilter: ACCURACY });
          dispatch(clearCellSelection());
        }}
      >
        {ACCURACY_BUTTON_TEXT}
      </AccuracyWrapper>
      <ProgressWrapper
        title={PROGRESS_BUTTON_TITLE}
        selected={currentSelection === PROGRESS}
        data-testid="progress-wrapper"
        onClick={() => {
          dispatch({ type: SELECT_ACCURACY_PROGRESS_TOGGLE, selectedFilter: PROGRESS });
          dispatch(clearCellSelection());
        }}
      >
        {PROGRESS_BUTTON_TEXT}
      </ProgressWrapper>

      <IconWrapper ref={targetRef} {...onHoverHandlers}>
        <SvgIcon icon={Info} />

        {showToolTip && (
          <ToolTip variant="light" targetRef={targetRef}>
            <ToolTipInfo>{currentSelection === ACCURACY ? ACCURACY_INFO_TEXT : PROGRESS_INFO_TEXT}</ToolTipInfo>
          </ToolTip>
        )}
      </IconWrapper>
    </AccuracyProgressWrapper>
  );
};

AccuracyProgressToggle.propTypes = {
  i18n: PropTypes.object
};

export default AccuracyProgressToggle;
